// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"caa8bbf5","177":"29e8e592","452":"fa1be950","978":"22799137"}[chunkId] + ".chunk.js";
};